var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { Wrapper, Header, Icon } from '@mademine/components';
import { I18n, Currency } from '@mademine/utils';
import classNames from 'classnames';
import { ReactComponent as IconLeft } from '../../assets/icon-arrow-bold-left.svg';
import { ReactComponent as SubscriptIcon } from '../../assets/icon-subscript.svg';
import styles from './style.module.less';
import { useData } from '../../hooks/useData';
var COLUM = 2;
var RelativeProductCard = function (_a) {
    var shop = _a.shop, stickerData = _a.stickerData, selectedColor = _a.selectedColor, selectedOption = _a.selectedOption, _b = _a.relativeProducts, relativeProducts = _b === void 0 ? [] : _b, onAdd = _a.onAdd, onPass = _a.onPass, onClose = _a.onClose;
    var _c = useData(), canvasData = _c.canvasData, currentSide = _c.currentSide, selectedRelatedProduct = _c.selectedRelatedProduct, setSelectedRelatedProduct = _c.setSelectedRelatedProduct;
    var _d = useState(0), cost = _d[0], setCost = _d[1];
    var _e = useState([]), selectIds = _e[0], setSelectIds = _e[1];
    var _f = useState(relativeProducts), filteredRelativeProducts = _f[0], setFilteredRelativeProducts = _f[1];
    var assembleStickerSku = function (templateId, color) {
        if (stickerData) {
            var templateIdMapper = {
                '1633': 110,
                '1634': 154,
                '1635': 156,
                '1636': 184
            };
            templateId = templateIdMapper[templateId]
                ? templateIdMapper[templateId]
                : templateId;
            var desireKey = "".concat(templateId, "-").concat(color[0].toUpperCase());
            for (var key in stickerData.body) {
                if (key === desireKey) {
                    return stickerData.body[key];
                }
            }
        }
        return false;
    };
    useEffect(function () {
        if (!assembleStickerSku(selectedOption.id, selectedColor[0].name)) {
            var relatedProductWithoutSticker = filteredRelativeProducts.filter(function (product) { return product.type !== 'sticker'; });
            setFilteredRelativeProducts(relatedProductWithoutSticker);
            console.error('no sticker sku matched');
        }
    }, [selectedOption, selectedColor]);
    var _content = useRef(null);
    var onConfirm = function () {
        if (selectIds.length === 0)
            return;
        var addProductData = selectIds.map(function (item) { return relativeProducts.find(function (configItem) { return configItem.id === item; }); });
        onAdd(addProductData);
    };
    useEffect(function () {
        filteredRelativeProducts.forEach(function (item, index) {
            if (item.autoSelect) {
                setSelectIds(__spreadArray(__spreadArray([], selectIds, true), [item.id], false));
                setSelectedRelatedProduct(__spreadArray(__spreadArray([], selectedRelatedProduct, true), [item], false));
                setCost(function (precost) { return precost + item.price; });
            }
        });
    }, []);
    var GridContent = useMemo(function () {
        var columData = [];
        filteredRelativeProducts.forEach(function (item, index) {
            var columIndex = index % COLUM;
            if (columData[columIndex] === undefined)
                columData[columIndex] = [item];
            else
                columData[columIndex].push(item);
        });
        var handleClick = function (clickItem) {
            var addPrice = clickItem.price;
            if (selectIds.includes(clickItem.id)) {
                addPrice = -addPrice;
                setSelectIds(selectIds.filter(function (item) {
                    return clickItem.id !== item;
                }));
                setSelectedRelatedProduct(selectedRelatedProduct.filter(function (item) {
                    return clickItem.id !== item.id;
                }));
            }
            else {
                setSelectIds(__spreadArray(__spreadArray([], selectIds, true), [clickItem.id], false));
                setSelectedRelatedProduct(__spreadArray(__spreadArray([], selectedRelatedProduct, true), [clickItem], false));
            }
            setCost(function (precost) { return precost + addPrice; });
        };
        return new Array(COLUM).fill(undefined).map(function (_, index) {
            var _a;
            return (_jsx("div", { className: "_sz-flex _sz-flex-col _sz-gap-4", children: (_a = columData[index]) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                    var _a;
                    var _b, _c;
                    return (_jsxs("div", { className: classNames('_sz-rounded-lg _sz-relative _sz-cursor-pointer', styles.card, (_a = {},
                            _a[styles['selected-card']] = selectIds.includes(item.id),
                            _a)), onClick: function () { return handleClick(item); }, children: [_jsxs("div", { className: "_sz-relative", children: [item.showCustomImage && (_jsx("img", { src: ((_c = (_b = canvasData.current[0]) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.compose) || '', className: "_sz-absolute _sz-z-[-1] _sz-aspect-square _sz-w-full _sz-rounded _sz-object-contain _sz-p-5" })), _jsx("img", { src: item.thumbnail, className: "_sz-aspect-square _sz-w-full _sz-rounded _sz-object-contain" }), _jsx("div", { className: "_sz-my-2 _sz-text-base _sz-font-extrabold !_sz-leading-[18px] _sz-text-[var(--sunzi-theme-color)]", children: Currency.format(item.price, shop.currency) }), _jsx("div", { className: "_sz-text-xs _sz-text-[rgba(0,0,0,0.5)]", children: item.title || '' })] }), selectIds.includes(item.id) && (_jsx(Icon, { className: "_sz-absolute -_sz-top-2 -_sz-right-2", color: "var(--sunzi-theme-color)", size: 32, children: _jsx(SubscriptIcon, {}) }))] }, item.id));
                }) }, index));
        });
    }, [selectIds, shop, selectedOption, selectedColor, filteredRelativeProducts]);
    return (_jsxs(Wrapper, { position: "absolute", className: "_sz-z-20 _sz-flex _sz-flex-col _sz-bg-white", children: [_jsx(Header, { className: " _sz-border-none", onClose: onClose, renderCloseContent: _jsx("div", { className: "_sz-p-1.5", onClick: onClose, children: _jsx(Icon, { size: 24, color: "rgba(0, 0, 0, 0.88)", children: _jsx(IconLeft, {}) }) }), renderContent: _jsx("span", { className: "-_sz-ml-[56px] _sz-flex _sz-w-[calc(100%+66px)] _sz-items-center _sz-justify-center _sz-text-base _sz-font-extrabold _sz-text-black", children: I18n.format('selected.product', {
                        value: selectIds.length > 0
                            ? "".concat(selectIds.length)
                            : I18n.format('none') || ''
                    }) }) }), _jsx("div", { className: "_sz-w-full _sz-flex-1 _sz-overflow-auto _sz-px-5", children: _jsx("div", { className: classNames('_sz-grid  _sz-gap-[15px] _sz-w-full _sz-pt-6 _sz-pb-[168px] sm:_sz-pb-[152px] _sz-justify-center _sz-grid-cols-2', styles.content), ref: _content, children: GridContent }) }), _jsxs("div", { className: "_sz-absolute _sz-bottom-0 _sz-w-full _sz-bg-[rgba(255,255,255,0.85)] _sz-px-4 _sz-pt-5 _sz-pb-9 _sz-backdrop-blur-xl sm:_sz-pb-5", children: [_jsx("button", { type: "button", className: classNames('_sz-h-13 _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border-none _sz-bg-black _sz-text-base _sz-font-extrabold _sz-text-white', {
                            '!_sz-bg-[rgba(0,0,0,0.16)] !_sz-cursor-not-allowed _sz-touch-none ': selectIds.length === 0
                        }), onClick: onConfirm, children: "".concat(cost === 0 ? '' : "+".concat(Currency.format(cost, shop.currency), " ")).concat(I18n.format('modules.global.add.cart')) }), _jsx("button", { type: "button", className: " _sz-mt-2 _sz-h-13 _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border _sz-border-solid _sz-border-black _sz-bg-white _sz-text-base _sz-font-extrabold _sz-text-black", onClick: onPass, children: I18n.format('modules.mini.me.no.thanks') })] })] }));
};
export default RelativeProductCard;
